import React from 'react';
import { useTranslation } from 'react-i18next';
import { getAssetPath } from '../../utils/publicPath';

import SectionTitle from '../../elements/section-title/SectionTitle';
import ProcesstData from '../../data/process/ProcessData.json';
import Tilty from 'react-tilty';

const getProcesstData = ProcesstData;

const ProcessOne = ({ variant = 'default' }) => {
  const { t } = useTranslation();

  if (variant === 'timeline') {
    const steps = t('approach.steps', { returnObjects: true }) || [];

    return (
      <section id="approach" className="section section-padding mutawir-approach">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-5">
              <div className="mutawir-section-heading">
                <span className="mutawir-tagline">{t('approach.tagline')}</span>
                <h2 className="title">{t('approach.title')}</h2>
                <p className="mutawir-section-description">{t('approach.description')}</p>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="mutawir-timeline">
                {steps.map((step, index) => (
                  <div className="mutawir-timeline__item" key={index}>
                    <div className="mutawir-timeline__index">{index + 1}</div>
                    <div className="mutawir-timeline__content">
                      <h3 className="mutawir-timeline__title">{step.title}</h3>
                      <p className="mutawir-timeline__description">{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <div className="section section-padding bg-color-light pb--70">
      <SectionTitle
        subtitle="Process"
        title="Our logo design process"
        description="Our comprehensive logo design strategy ensures a perfectly crafted logo for your business."
        textAlignment=""
        textColor="mb--90"
      />
      <div className="container">
        {getProcesstData.map((data) => (
          <div key={data.id} className={`process-work ${(data.id % 2 === 0) ? 'content-reverse' : ''}`}>
            <Tilty perspective={2000}>
              <div className="thumbnail">
                <img src={getAssetPath(data.thumb)} alt="Thumbnail" />
              </div>
            </Tilty>
            <div className="content">
              <span className="subtitle">{data.subtitle}</span>
              <h3 className="title">{data.title}</h3>
              <p>{data.paragraph}</p>
            </div>
          </div>
        ))}
      </div>
      <ul className="shape-group-17 list-unstyled">
        <li className="shape shape-1"><img src={getAssetPath('/images/others/bubble-24.png')} alt="Bubble" /></li>
        <li className="shape shape-2"><img src={getAssetPath('/images/others/bubble-23.png')} alt="Bubble" /></li>
        <li className="shape shape-3"><img src={getAssetPath('/images/others/line-4.png')} alt="Line" /></li>
        <li className="shape shape-4"><img src={getAssetPath('/images/others/line-5.png')} alt="Line" /></li>
        <li className="shape shape-5"><img src={getAssetPath('/images/others/line-4.png')} alt="Line" /></li>
        <li className="shape shape-6"><img src={getAssetPath('/images/others/line-5.png')} alt="Line" /></li>
      </ul>
    </div>
  );
};

export default ProcessOne;
